"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.terminalOutput = exports.DEFAULT_OPTIONS = exports.simplifyTestResult = exports.DEFAULT_WARNING_ORDER = void 0;
const capitalize_1 = __importDefault(require("capitalize"));
const indent_string_1 = __importDefault(require("indent-string"));
const phrases_1 = __importDefault(require("./phrases"));
exports.DEFAULT_WARNING_ORDER = [
    "checkstyle",
    "ktlint",
    "recursion",
    "complexity",
    "features",
    "lineCount",
    "executioncount",
    "extraOutput",
    "memoryAllocation",
    "coverage",
    "classSize",
];
const simplifyTestResult = (result) => {
    const { passed } = result;
    if (passed) {
        return [];
    }
    const { tests } = result;
    const simplestFailure = tests
        .filter(({ passed, explanation }) => !passed && explanation)
        .sort((a, b) => a.explanation.length - b.explanation.length)[0];
    if (!simplestFailure) {
        return [];
    }
    if (simplestFailure.type === "STATIC_METHOD") {
        return [simplestFailure];
    }
    else {
        return tests.filter((test) => test.runnerID === simplestFailure.runnerID).sort((a, b) => a.stepCount - b.stepCount);
    }
};
exports.simplifyTestResult = simplifyTestResult;
exports.DEFAULT_OPTIONS = {
    successMessage: "Your code passed all tests and code quality checks.",
    defaultIndentation: 2,
};
const terminalOutput = (results, contents, options = exports.DEFAULT_OPTIONS) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    const outputOptions = Object.assign(Object.assign({}, exports.DEFAULT_OPTIONS), options);
    const indentation = outputOptions.defaultIndentation;
    const testingCompleted = results.completedSteps.includes("testing");
    const testingSucceeded = results.completedSteps.includes("testing") && results.succeeded === true;
    if (results.failedSteps.length > 0 || results.timeout) {
        const { failed } = results;
        if (results.timeout) {
            return {
                error: true,
                retry: true,
                output: `Testing your submission timed out.\n${(0, indent_string_1.default)(`Check for unterminated loops.\nOr your algorithm may be too slow.`, indentation)}`,
            };
        }
        else if (failed.templateSubmission) {
            return { error: true, retry: true, output: `Templating failed. Please report a bug.` };
        }
        else if (failed.checkstyle) {
            const output = ((_a = failed.checkstyle) === null || _a === void 0 ? void 0 : _a.errors.map(({ location: { source, line }, message }) => {
                return `${source === "" ? "Line " : `${source}:`}${line}: checkstyle error: ${message}`;
            }).join("\n")) || "";
            const errorCount = Object.keys(((_b = failed.checkstyle) === null || _b === void 0 ? void 0 : _b.errors) || {}).length;
            return { error: true, retry: false, output: `${output}\n${errorCount} error${errorCount > 1 ? "s" : ""}` };
        }
        else if (failed.ktlint) {
            const output = ((_c = failed.ktlint) === null || _c === void 0 ? void 0 : _c.errors.map(({ location: { source, line }, detail }) => {
                return `${source === "" ? "Line " : `${source}:`}${line}: ktlint error: ${detail}`;
            }).join("\n")) || "";
            const errorCount = Object.keys(((_d = failed.ktlint) === null || _d === void 0 ? void 0 : _d.errors) || {}).length;
            return { error: true, retry: false, output: `${output}\n${errorCount} error${errorCount > 1 ? "s" : ""}` };
        }
        else if (failed.compileSubmission) {
            const output = failed.compileSubmission.errors
                .map((error) => {
                const { location, message } = error;
                if (location) {
                    const { source, line, column } = location;
                    const originalLine = contents.split("\n")[line - 1];
                    const firstErrorLine = message.split("\n").slice(0, 1).join();
                    const restOfError = message
                        .split("\n")
                        .slice(1)
                        .filter((line) => {
                        return !(source === "" && line.trim().startsWith("location: class"));
                    })
                        .join("\n");
                    return `${source === "" ? "Line " : `${source}:`}${line}: error: ${firstErrorLine}\n${originalLine ? originalLine + "\n" + new Array(column >= 0 ? column : 0).join(" ") + "^" : ""}${restOfError ? "\n" + restOfError : ""}`;
                }
                else {
                    return message;
                }
            })
                .join("\n") || "";
            const errorCount = Object.keys(failed.compileSubmission.errors).length;
            return { error: true, retry: false, output: `${output}\n${errorCount} error${errorCount > 1 ? "s" : ""}` };
        }
        else if (failed.checkInitialSubmission) {
            return {
                error: true,
                retry: false,
                output: `Your submission had errors:\n${(0, indent_string_1.default)(failed.checkInitialSubmission, indentation)}`,
            };
        }
        else if (failed.checkCompiledSubmission ||
            (failed.checkExecutedSubmission && (!testingCompleted || testingSucceeded)) ||
            failed.features ||
            failed.classSize) {
            return {
                error: true,
                retry: false,
                output: `Your submission had errors:\n${(0, indent_string_1.default)((failed.checkCompiledSubmission ||
                    failed.checkExecutedSubmission ||
                    failed.features ||
                    failed.classSize), indentation)}`,
            };
        }
        else if (failed.complexity) {
            return {
                error: true,
                retry: false,
                output: `Your submission was too complex to test:\n${(0, indent_string_1.default)(failed.complexity, indentation)}`,
            };
        }
        else if (failed.lineCount) {
            return {
                error: true,
                retry: false,
                output: `Your submission was too long to test:\n${(0, indent_string_1.default)(failed.lineCount, indentation)}`,
            };
        }
    }
    if (!testingCompleted) {
        return {
            error: true,
            retry: true,
            output: `Didn't return a testing result. If this happens repeatedly, please report a bug.`,
        };
    }
    const { complete, completedSteps, failedLinting } = results;
    const warnings = {};
    if (failedLinting === true) {
        if (completedSteps.includes("checkstyle")) {
            const output = ((_e = complete.checkstyle) === null || _e === void 0 ? void 0 : _e.errors.map(({ location: { source, line }, message }) => {
                return `${source === "" ? "  Line " : `  ${source}:`}${line}: checkstyle error: ${message}`;
            }).join("\n")) || "";
            const errorCount = Object.keys(((_f = complete.checkstyle) === null || _f === void 0 ? void 0 : _f.errors) || {}).length;
            warnings["checkstyle"] = `Your submission has checkstyle errors:\n${output}\n${errorCount} error${errorCount > 1 ? "s" : ""}`;
        }
        else if (completedSteps.includes("ktlint")) {
            const output = ((_g = complete.ktlint) === null || _g === void 0 ? void 0 : _g.errors.map(({ location: { source, line }, detail }) => {
                return `${source === "" ? "  Line " : `  ${source}:`}${line}: ktlint error: ${detail}`;
            }).join("\n")) || "";
            const errorCount = Object.keys(((_h = complete.ktlint) === null || _h === void 0 ? void 0 : _h.errors) || {}).length;
            warnings["ktlint"] = `Your submission has ktlint errors:\n${output}\n${errorCount} error${errorCount > 1 ? "s" : ""}`;
        }
    }
    if (((_j = complete.complexity) === null || _j === void 0 ? void 0 : _j.failed) === true) {
        const { solution, submission } = complete.complexity;
        warnings["complexity"] = `Your submission is too complicated:\n${(0, indent_string_1.default)(`The solution has a cyclomaticy complexity of ${solution}.\nYour submission has ${submission}.`, indentation)}`;
    }
    if (((_k = complete.classSize) === null || _k === void 0 ? void 0 : _k.failed) === true) {
        const { solution, submission } = complete.classSize;
        warnings["classSize"] = `Your submission class is too large:\n${(0, indent_string_1.default)(`The solution is ${pluralize("byte", solution)} bytes.\nYour submission is ${submission}.`, indentation)}`;
    }
    if (((_l = complete.features) === null || _l === void 0 ? void 0 : _l.failed) === true) {
        const { errors } = complete.features;
        warnings["features"] = `Your submission generated design warnings:\n${(0, indent_string_1.default)(errors.join("\n"), indentation)}`;
    }
    if (((_m = complete.lineCount) === null || _m === void 0 ? void 0 : _m.failed) === true) {
        const { solution, submission } = complete.lineCount;
        warnings["lineCount"] = `Your submission is too long:\n${(0, indent_string_1.default)(`The solution has ${solution.source} source ${pluralize("line", solution.source)}.\nYour submission has ${submission.source}.`, indentation)}`;
    }
    if (((_o = complete.coverage) === null || _o === void 0 ? void 0 : _o.failed) === true) {
        warnings["coverage"] = `Your submission contains unexecuted code:\n${(0, indent_string_1.default)(`You have ${complete.coverage.increase} more lines of unexecuted code than the solution.\nWhich exceeds the limit of ${complete.coverage.limit}.`, indentation)}`;
    }
    if (((_p = complete.executionCount) === null || _p === void 0 ? void 0 : _p.failed) === true) {
        const { solution, submission } = complete.executionCount;
        warnings["executioncount"] = `Your submission is too inefficient:\n${(0, indent_string_1.default)(`The solution executed ${solution} ${pluralize("line", solution)} to complete the tests.\nYour submission took ${submission} (${Math.round((submission / solution) * 100)}%).`, indentation)}`;
    }
    if (((_q = complete.memoryAllocation) === null || _q === void 0 ? void 0 : _q.failed) === true) {
        const { solution, submission } = complete.memoryAllocation;
        warnings["memoryAllocation"] = `Your submission uses too much memory:\n${(0, indent_string_1.default)(`The solution allocated ${solution} bytes to complete the tests.\nYour submission needed ${submission} (${Math.round((submission / solution) * 100)}%).`, indentation)}`;
    }
    if (((_r = complete.recursion) === null || _r === void 0 ? void 0 : _r.failed) === true) {
        warnings["recursion"] =
            `Your submission did not implement required recursive methods recursively: ${complete.recursion.missingMethods.join(", ")}`;
    }
    if (((_s = complete.extraOutput) === null || _s === void 0 ? void 0 : _s.failed) === true) {
        warnings["extraOutput"] = `Your submission generated unnecessary output. Please remove any debugging statements.`;
    }
    if (results.succeeded !== true) {
        if (results.failureCount === undefined) {
            return {
                error: true,
                retry: true,
                output: "Error printing testing output. If this happens repeatedly, please report a bug.",
            };
        }
        const testing = results.complete.testing;
        const failures = (0, exports.simplifyTestResult)(testing);
        const lastFailure = failures[failures.length - 1];
        let message = `Ran ${testing.testCount} test${testing.testCount > 1 ? "s" : ""}. Stopped after finding ${results.failureCount} failure${results.failureCount > 1 ? "s" : ""}${results.failureCount > 1 ? `. Here is one:` : ":"}\n\n${lastFailure.explanation}`;
        if (lastFailure.submissionStackTrace) {
            message += `\n\nSubmission exception stack trace:\n${(0, indent_string_1.default)(lastFailure.submissionStackTrace, indentation)}`;
        }
        const output = failures
            .map((test) => test.output)
            .filter((output) => output !== "")
            .join("")
            .trim();
        const allOutputFailures = lastFailure.differs &&
            lastFailure.differs.filter((differ) => ["STDOUT", "STDERR", "INTERLEAVED_OUTPUT"].includes(differ)).length === 0;
        if (output && (!lastFailure.differs || allOutputFailures)) {
            message += `\n\nTesting output:\n${output}`;
        }
        if (failures.length > 1) {
            message += `\n\nTesting method sequence:\n${(0, indent_string_1.default)(failures.map((test) => test.methodCall).join("\n"), indentation)}`;
        }
        warnings["testing"] = message;
    }
    const { showWarnings, treatAsErrors, showWithTestResults } = outputOptions;
    if (showWarnings) {
        for (const warning of Object.keys(warnings)) {
            if (warning !== "testing" && !showWarnings.includes(warning)) {
                delete warnings[warning];
            }
        }
    }
    const wellDone = (0, capitalize_1.default)(phrases_1.default[Math.floor(Math.random() * phrases_1.default.length)]);
    if (Object.keys(warnings).length === 0) {
        return { error: false, retry: false, output: `${outputOptions.successMessage} ${wellDone}!` };
    }
    else if (warnings["testing"]) {
        let header;
        for (const which of (_t = options.warningOrder) !== null && _t !== void 0 ? _t : exports.DEFAULT_WARNING_ORDER) {
            if (warnings[which] && showWithTestResults && showWithTestResults.includes(which)) {
                header = `Your submission will eventually be considered incorrect because of this error:\n${(0, indent_string_1.default)(warnings[which], indentation)}`;
            }
        }
        if (header) {
            return { error: false, retry: false, output: `${header}\n---\n${warnings["testing"]}` };
        }
        else {
            return { error: false, retry: false, output: warnings["testing"] };
        }
    }
    else {
        for (const which of (_u = options.warningOrder) !== null && _u !== void 0 ? _u : exports.DEFAULT_WARNING_ORDER) {
            if (warnings[which]) {
                if (treatAsErrors && treatAsErrors.includes(which)) {
                    return {
                        error: false,
                        retry: false,
                        output: `Your code passed the tests, but was considered incorrect because of this error:\n${(0, indent_string_1.default)(warnings[which], indentation)}`,
                    };
                }
                else {
                    return {
                        error: false,
                        retry: false,
                        output: `Your code passed all the tests! ${wellDone}!\n\nBut we noticed something you could improve:\n${(0, indent_string_1.default)(warnings[which], indentation)}`,
                    };
                }
            }
        }
    }
    return {
        error: true,
        retry: true,
        output: "Error printing testing output. If this happens repeatedly, please report a bug.",
    };
};
exports.terminalOutput = terminalOutput;
const pluralize = (input, count, plural) => {
    if (count === 1) {
        return input;
    }
    else if (plural) {
        return plural;
    }
    else {
        return `${input}s`;
    }
};
//# sourceMappingURL=index.js.map